module.exports = __webpack_public_path__ + "img/Care.b0856adb.png";